// extracted by mini-css-extract-plugin
export default {"demoInfo":"approvalBox_demoInfo__lYqJT","slideTransition":"approvalBox_slideTransition__w3A78"};